import axios, {AxiosResponse} from 'axios'
import {ApiResponse} from '../../../../shared/models/ApiModels'
import type {IXmlTariffPriceRow, VehicleGroupFilter} from './XmlTariffDetailModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const XML_TARIFF_PRICE_ENTRY_URL = `${API_URL}api/v1/definition/xmlRate/tariffPriceEntry`
export const XML_TARIFF_PRICE_ENTRY_SAVE_URL = `${API_URL}api/v1/definition/xmlRate/tariffPriceEntry/save`

export interface IXmlTariffPriceEntryPayload {
  id?: string | null
  createdDate?: string | null
  updatedDate?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  deleted?: boolean
  xmlRatePriceList?: IXmlTariffPriceRow[]
  headerList?: string[]
}

/** Xml tarife fiyat girişi tablosu — tarife id ve/veya araç grubu filtresi ile */
export function getXmlTariffPriceEntry(
  xmlRateId: string | undefined | null,
  vehicleGroupFilter: VehicleGroupFilter
): Promise<AxiosResponse<ApiResponse<IXmlTariffPriceEntryPayload | unknown[]>>> {
  return axios.get(XML_TARIFF_PRICE_ENTRY_URL, {
    params: {
      ...(xmlRateId ? {xmlRateId} : {}),
      vehicleGroupFilter,
    },
  })
}

export interface IXmlTariffPriceEntrySaveRequest {
  xmlRateId?: string | null
  xmlRatePriceList: IXmlTariffPriceRow[]
}

/** Xml tarife fiyat girişi kaydet */
export function saveXmlTariffPriceEntry(
  data: IXmlTariffPriceEntrySaveRequest
): Promise<AxiosResponse<ApiResponse<unknown>>> {
  return axios.post(XML_TARIFF_PRICE_ENTRY_SAVE_URL, data)
}
